<template>
  <div>
<!--    <a role="button" class="btn btn-primary" @click="submit()"><i class="fas fa-save"></i></a>-->
    <!--    <a class="btn btn-primary" @click="DataItem_AddLast"><i class="fas fa-plus-circle"></i></a>-->
    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th>功能</th>
        <th>序號</th>
        <th>日期</th>
        <th>姓名</th>
        <th>電話</th>
        <th>項目</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in this.datas" :key="index">
        <td width="200px">
          <a role="button" class="btn btn-danger" href="#" @click="deleteData(item.id)">刪除</a>
        </td>
        <td>
          {{index+1}}
        </td>
        <td width="200px">
          {{item.created_at|fmtDateUTC}}
        </td>
        <td width="220px">
          {{item.name}}
        </td>
        <td width="120px">
          {{item.tel}}
        </td>
        <td>
          {{item.options}}
        </td>
      </tr>

      </tbody>
    </table>

  </div>
</template>

<script>
/**

 **/


import Vue from "vue";
import apiFireGods from "@/views/fireGods/js/apiFireGods";

export default {
  //name: "setting",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datas:{

      },
    };
  },
  methods: {
    loadData() {
      // let data=apiAdmin.api_getContent(this.queryType);
      // debugger // eslint-disable-line
      // console.log(data);
      let that=this;

      apiFireGods.api_Admin_EventApplicants2_Query(this.id).then((data)=>{
        let dataApi=data.data.data;
        // let dataApi=apiAdmin.init(data.data.data);
        that.datas=dataApi;
      })
    },
    // submit(){
    //   debugger // eslint-disable-line
    //   apiFireGods.api_Admin_EventDefine_Save(this.datas).then((data)=>{
    //     console.log(data);
    //     alert('儲存成功')
    //   })
    // },
    convertToRealUrl(url){
      return Vue.prototype.$apiAdress.replace(/\/$/, "") +url;
    },
    deleteData(id){
      let that=this;
      if(confirm("確定刪除?")){
        apiFireGods.api_Admin_EventApplicants2_Delete(id).then((data)=>{
          that.loadData();
        })
      }
    },
  },
  mounted() {
    this.id=this.$route.query.id
    this.loadData()
  },
}
</script>

<style scoped>
#tblMain{
  width: 1000px;
}
.btn{
  color: white !important;
  margin: 5px;
  /*width: 40px;*/
}
</style>
